import React, { useState, useEffect } from 'react';
import { FaHashtag, FaClock, FaPlus, FaMinus, FaRupeeSign, FaListOl, FaCalendarAlt, FaMoneyBillWave } from 'react-icons/fa';
import Swal from 'sweetalert2';


const API_URL = "https://api.experts4u.in/api/v2/Spcashbackrules/spcashbackrule";

const Spcashbackrules = () => {
  const [maxCashbackPerJob, setMaxCashbackPerJob] = useState('');
  const [cashbackTimeLimit, setCashbackTimeLimit] = useState('');
  const [priceSlots, setPriceSlots] = useState([{ price: '' }]);
  const [minOrderValue, setMinOrderValue] = useState('');
  const [cashbackValidity, setCashbackValidity] = useState('');
  const [ruleId, setRuleId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Fetch existing rules on mount
  useEffect(() => {
    const fetchRules = async () => {
      setLoading(true);
      setError('');
      setSuccess('');
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(API_URL, {
          method: 'GET',
          headers: token ? { 'Authorization': `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error('Failed to fetch rules');
        const data = await res.json();
        // Handle API response with 'data' property
        const rule = data && data.data ? data.data : (Array.isArray(data) ? data[0] : data);
        if (rule && rule._id) {
          setRuleId(rule._id);
          setMaxCashbackPerJob(rule.maxCashbackPerJob || '');
          setCashbackTimeLimit(rule.cashbackTimeLimit || '');
          setPriceSlots(rule.priceSlots && rule.priceSlots.length > 0 ? rule.priceSlots : [{ price: '' }]);
          setMinOrderValue(rule.minOrderValue || '');
          setCashbackValidity(rule.cashbackValidity || '');
        }
      } catch (err) {
        setError('Failed to fetch rules');
      } finally {
        setLoading(false);
      }
    };
    fetchRules();
  }, []);

  const handlePriceSlotChange = (index, value) => {
    const updatedSlots = priceSlots.map((slot, i) =>
      i === index ? { price: value } : slot
    );
    setPriceSlots(updatedSlots);
  };

  const addPriceSlot = () => {
    setPriceSlots([...priceSlots, { price: '' }]);
  };

  const removePriceSlot = (index) => {
    setPriceSlots(priceSlots.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('No token found. Please login.');
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      myHeaders.append('Authorization', `Bearer ${token}`);
      const body = JSON.stringify({
        maxCashbackPerJob: Number(maxCashbackPerJob),
        cashbackTimeLimit: Number(cashbackTimeLimit),
        priceSlots: priceSlots.map(slot => ({ price: Number(slot.price) })),
        minOrderValue: Number(minOrderValue),
        cashbackValidity: Number(cashbackValidity)
      });
      const method = ruleId ? 'PUT' : 'POST';
      const url = ruleId ? `${API_URL}/${ruleId}` : API_URL;
      const res = await fetch(url, {
        method,
        headers: myHeaders,
        body,
        redirect: 'follow'
      });
      if (!res.ok) throw new Error('Failed to save rules');
      const data = await res.json();
      const saved = data?.data || data;
      if (saved && saved._id) setRuleId(saved._id);
      Swal.fire({
        title: 'Success',
        text: 'Rules saved successfully!',
        icon: 'success',
        confirmButtonText: 'OK'
      });
      setSuccess('Rules saved successfully!');
    } catch (err) {
      Swal.fire({
        title: 'Error',
        text: err.message || 'Failed to save rules',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      setError(err.message || 'Failed to save rules');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5 ">
      <div className="row justify-content-center pt-5">
        <div className="col-md-12">
          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-header bg-primary text-white rounded-top-4">
              <h3 className="mb-0 d-flex align-items-center">
                <FaMoneyBillWave className="me-2 mr-2" /> Service Provider Cashback Rules
              </h3>
            </div>
            <div className="card-body p-4">
              {loading && <div className="alert alert-info">Loading...</div>}
              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">{success}</div>}
              <form onSubmit={handleSubmit}>
                {/* 1. Max cashback per job */}
                <div className="row">
                <div className="mb-4 col-md-6">
                  <label className="form-label fw-bold">
                    <FaHashtag className="me-2 text-primary mr-2" />How many times cashback can be given per job
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-lg"
                    min="1"
                    value={maxCashbackPerJob}
                    onChange={e => setMaxCashbackPerJob(e.target.value)}
                    placeholder="Enter max cashback times per job"
                    required
                  />
                </div>
                {/* 2. Cashback time limit (hours) */}
                <div className="mb-4 col-md-6">
                  <label className="form-label fw-bold">
                    <FaClock className="me-2 text-primary mr-2" />Cashback time limit (in hours for service providers only.)
                  </label>
                  <input
                    type="number"
                    className="form-control form-control-lg"
                    min="1"
                    value={cashbackTimeLimit}
                    onChange={e => setCashbackTimeLimit(e.target.value)}
                    placeholder="Enter time limit in hours"
                    required
                  />
                </div>
                </div>


                <div className="row">

{/* 4. Minimum order value */}
<div className="mb-4 col-md-6">
  <label className="form-label fw-bold">
    <FaRupeeSign className="me-2 text-primary mr-2" />Minimum order value
  </label>
  <input
    type="number"
    className="form-control form-control-lg"
    min="0"
    value={minOrderValue}
    onChange={e => setMinOrderValue(e.target.value)}
    placeholder="Enter minimum order value"
    required
  />
</div>
{/* 5. Cashback validity (days) */}
<div className="mb-4 col-md-6">
  <label className="form-label fw-bold">
    <FaCalendarAlt className="me-2 text-primary mr-2" />Cashback validity (in days for Users only)
  </label>
  <input
    type="number"
    className="form-control form-control-lg"
    min="1"
    value={cashbackValidity}
    onChange={e => setCashbackValidity(e.target.value)}
    placeholder="Enter validity in days"
    required
  />
</div>
</div>


                {/* 3. Price slots (only price) */}
                <div className="mb-4">
                  <label className="form-label fw-bold">
                    <FaListOl className="me-2 text-primary mr-2" />Price Slots
                  </label>
                  {priceSlots.map((slot, idx) => (
                    <div className="row g-2 align-items-end mb-2" key={idx}>
                      <div className="col-md-10">
                        <div className="input-group">
                          <span className="input-group-text"><FaRupeeSign /></span>
                          <input
                            type="number"
                            className="form-control"
                            min="0"
                            value={slot.price}
                            onChange={e => handlePriceSlotChange(idx, e.target.value)}
                            placeholder="Price"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-2 d-flex gap-2">
                        {priceSlots.length > 1 && (
                          <button type="button" className="btn btn-danger btn-sm mr-2" onClick={() => removePriceSlot(idx)}>
                            <FaMinus />
                          </button>
                        )}
                        {idx === priceSlots.length - 1 && (
                          <button type="button" className="btn btn-success btn-sm" onClick={addPriceSlot}>
                            <FaPlus />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              
                <div className="d-grid mt-4">
                  <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
                    <FaMoneyBillWave className="me-2 mr-2" />{ruleId ? 'Update' : 'Save'} Cashback Rules
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spcashbackrules;